export default {
  NEED_INFO: 'Need Info',
  PENDING: 'Pending',
  IN_PROGRESS: 'In Progress',
  FAILED: 'Failed',
  COMPLETED: 'Registered',
  NOT_REQUIRED: 'Bypassed',
};
